import { IButton } from "types/gaiaComponents/button";
import React from "react";


export const ButtonType = {
    PRIMARY: "primary",
    SECONDARY: "secondary",
    GHOST: "ghost",
    TRANSPARENT: "transparent",
}
export const Button = React.forwardRef((props: IButton, ref) => {
    return (
        <button className={`ga-button ga-button--${props.type}${props.iconOnly ? " ga-button--icon-only" : ""}${props.extraClassName? " "+props.extraClassName: ""}`}
                id={props.id}
                type={"button"}
                //@ts-ignore
                ref={ref}
                disabled={props.disabled}
                onClick={props.onClick}
                onBlur={props.onBlur}
                title={props.title}
                tabIndex={props.tabIndex}
                data-cy={props.dataCy}
                data-testid={props.dataTestId}
                data-target={props.dataTarget}
                data-toggle={props.dataToggle}
                aria-label={props.ariaLabel}>
            {props.icon}
            {props.text}
            {props.rightIcon}
        </button>
    )
});